import { ChangeDetectionStrategy, Component, computed, inject, viewChild } from '@angular/core';
import { combineLatest, map, Observable, ReplaySubject, switchMap } from 'rxjs';
import { BasicFilterExpression, DataService, ExportDataOptions, ExportFilter } from '../../../services/data.service';
import { DashboardLeerling, LeerlingDetail } from '../../Details';
import { DetailsDashboard } from '../../base-details-panel/details.dashboard';
import { ExportOptions } from '../../../services/export.service';
import { Table } from '@cumlaude/metadata';
import { AsyncPipe } from '@angular/common';
import { FilterPanelComponent } from '../../../filter-panel/filter-panel.component';
import { FilterBarComponent } from '../../../filter-bar/filter-bar.component';
import { FilterName } from '../../../services/filter-name';
import { AanwezigheidRedenenComponent } from '../../../dashboards/aanwezigheid-statistieken/aanwezigheid-redenen/aanwezigheid-redenen.component';
import { Dashboard } from '../../../shared/dashboard/base-dashboard/dashboard';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
	selector: 'app-leerling-afwezigheidsredenen-details-panel',
	templateUrl: './leerling-afwezigheidsredenen-details-panel.component.html',
	styleUrls: ['./leerling-afwezigheidsredenen-details-panel.component.scss'],
	imports: [FilterPanelComponent, AsyncPipe, FilterBarComponent, AanwezigheidRedenenComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeerlingAfwezigheidsredenenDetailsPanelComponent extends Dashboard implements DetailsDashboard<LeerlingDetail> {
	private readonly dataService = inject(DataService);

	leerling$ = new ReplaySubject<DashboardLeerling>(1);
	leerling = toSignal(this.leerling$);

	aanwezigheidRedenen = viewChild.required(AanwezigheidRedenenComponent);

	setSelected(selected: LeerlingDetail, schooljaar?: string) {
		this.leerling$.next({
			leerling: selected,
			schooljaarInfo: schooljaar ?? selected.lb_nm_schooljaar,
		});
	}

	doDetailsExport(exportOptions: ExportOptions) {
		this.doExport(this.filterExpressions(), this.permanentFilters(), exportOptions);
	}

	override getExportData(options: ExportDataOptions): Observable<Blob> {
		return this.dataService.getAanwezigheidExportData(options);
	}

	readonly factTable = Table.fac_aw_aanwezigheid;
	readonly defaultFilters: FilterName[] = ['aw_nm_schooljaar', 'aw_fun_nm_vak', 'aw_fun_nm_abs_reden'];

	permanentFilters = computed(() => {
		return [
			new BasicFilterExpression(['aw_nr_leerling'], this.leerling()?.leerling.lb_nr_leerling),
			new BasicFilterExpression(['aw_is_presentieregistratie_verwerkt'], 1),
		];
	});

	schooljaarFilterOverride = computed(() => ({ aw_nm_schooljaar: this.leerling()?.schooljaarInfo }));

	override exportAsTable(exportOptions: ExportOptions, _title: string, filters: ExportFilter[]): Observable<Blob> {
		return combineLatest([this.aanwezigheidRedenen().exportAsTable(exportOptions, filters)]).pipe(
			map((pages) => {
				return {
					showDatum: exportOptions.showDatum,
					pages,
				};
			}),
			switchMap((tableExport) => this.dataService.getTableExport(tableExport))
		);
	}
}
